import React, { useRef } from 'react';
import styled from '@emotion/styled';

import { useToggle } from '@common/hooks';
import { DESCRIPTION_MIN_HEIGHT } from '@domains/pdp-common';

interface Props {
  opener: React.ReactNode;
  closer: React.ReactNode;
  height?: number;
  onUnfoldClick?: () => void;
  onToggle?: () => void;
  children: React.ReactNode;
  initialState?: boolean;
}

export const FoldableComponent: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  height = DESCRIPTION_MIN_HEIGHT,
  closer,
  opener,
  onUnfoldClick,
  onToggle,
  initialState,
}: Props) => {
  const [is_opened, toggle] = useToggle(initialState);
  const targetRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    toggle();
    onToggle?.();

    if (is_opened) {
      setTimeout(() => targetRef?.current?.scrollIntoView({ block: 'center' }));
    } else {
      onUnfoldClick?.();
    }
  };

  return (
    <>
      <Container $height={height} is_opened={is_opened}>
        {children}
        {!is_opened && <Gradiant />}
      </Container>
      <ButtonWrapper ref={targetRef} onClick={handleToggle}>
        {is_opened ? closer : opener}
      </ButtonWrapper>
    </>
  );
};

const Container = styled.div<{ $height: number; is_opened: boolean }>`
  position: relative;

  overflow: ${({ is_opened }) => (is_opened ? 'unset' : 'hidden')};
  height: ${({ is_opened, $height }) => (is_opened ? '100%' : `${$height}px`)};
`;

const Gradiant = styled.div`
  position: absolute;
  bottom: 0;
  height: 120px;
  width: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgb(255, 255, 255));
`;

const ButtonWrapper = styled.div`
  margin: 0 16px 24px;
`;
